import React, { useState } from "react";
import SubHeader from "../general/SubHeader";
import Login from "../general/Login";
import Signup from "../general/Signup";

const Account = () => {
  const [showLogin, setShowLogin] = useState(true);

  return (
    <>
      <SubHeader message="Account" />

      {showLogin ? (
        <Login setShowLogin={setShowLogin} />
      ) : (
        <Signup setShowSignup={setShowLogin} setShowLogin={setShowLogin} />
      )}
    </>
  );
};

export default Account;
